import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { trackInitiateCheckout } from '../utils/metaPixel';
export function BonusClosingSection() {
  const handlePurchaseClick = () => {
    trackInitiateCheckout();
  };
  return <Section className="px-6 md:px-12 max-w-3xl mx-auto text-center" data-id="element-40">
      <div className="space-y-8" data-id="element-41">
        <div className="font-mono text-2xl md:text-3xl font-bold space-y-2" data-id="element-42">
          <p className="text-gray-400 line-through decoration-red-500/50" data-id="element-43">
            $188 USD en valor.
          </p>
          <p className="text-[#f0c674] text-glow" data-id="element-44">
            <span className="line-through decoration-red-500/50 text-gray-500 mr-3" data-id="element-45">
              $47 USD
            </span>{' '}
            $6 USD hoy.
          </p>
        </div>

        <div className="font-sans text-lg text-gray-300 space-y-4 max-w-2xl mx-auto" data-id="element-46">
          <p data-id="element-47">Los bonos son tuyos desde el momento en que accedés.</p>
          <p data-id="element-48">
            Sin esperar. Sin cumplir condiciones. Sin "disponibles en 7 días".
          </p>
          <p className="font-medium text-gray-100" data-id="element-49">
            Todo junto, todo ahora, todo por $6.
          </p>
        </div>

        <div className="py-8 border-y border-gray-800 my-12" data-id="element-50">
          <h3 className="font-serif text-2xl font-bold text-[#f0c674] mb-6" data-id="element-51">
            ¿Por qué $6 USD?
          </h3>
          <div className="font-sans text-gray-400 space-y-4 text-left md:text-center" data-id="element-52">
            <p data-id="element-53">
              Porque no quiero que el precio sea la razón por la que seguís
              operando de la misma manera el mes que viene.
            </p>
            <p data-id="element-54">
              Quiero que lo implementes. Quiero que funcione. Y quiero que
              cuando funcione, seas el ejemplo que le muestro al próximo.
            </p>
            <p className="font-medium text-gray-300 italic" data-id="element-55">
              Eso vale más para mí que cobrar $47.
            </p>
          </div>
        </div>

        <div className="max-w-md mx-auto pt-4" data-id="element-56">
          <Button fullWidth className="py-5 text-lg" href="https://www.jwmoka.shop/cart/46286948335787:1" onClick={handlePurchaseClick} data-id="element-57">
            ACCEDÉ AHORA POR $6 USD
          </Button>

          <div className="mt-6 space-y-2" data-id="element-58">
            <p className="font-sans font-medium text-gray-300" data-id="element-59">
              Todo el programa + los 3 bonos incluidos
            </p>
            <p className="font-sans text-sm text-gray-500 flex items-center justify-center space-x-2" data-id="element-60">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500/50" data-id="element-61" />
              <span data-id="element-62">Acceso inmediato · Sin suscripción · Sin letra chica</span>
            </p>
          </div>
        </div>
      </div>
    </Section>;
}